/**
 * Rozhraní pro asynchronní události, na které je možné čekat a mohou vracet hodnotu
 */
export interface IAwaitableEvent<T> extends CustomEvent {
    /**
     * Vyvolávající má povinost počkat na výsledek tohoto promisu před pokračováním
     */
    readonly resultAwaiter: Promise<T | undefined>;

    /**
     * Zaregistruje promise, na který má volající čekat
     * @param resultPromise registovaný úkol, na který se má počkat
     */
    readonly enqueueResult: (resultPromise: (previousResult: T | undefined) => Promise<T | undefined>) => void;
}

export class AwaitableEvent<T> extends CustomEvent<T> implements IAwaitableEvent<T> {
    public readonly resultAwaiter: Promise<T | undefined>;

    /**
     * Vytvoří data pro asynchronní událost
     * @param defaultResultValue defaultní hodnota výsledku, která je vrácena, pokud ji žádný konzument nezmění
     * @param detail další libovolná data události
     */
    constructor(eventName: string, defaultResultValue?: T, detail?: any) {
        super(eventName, detail);

        this.resultAwaiter = Promise.resolve(defaultResultValue);

        this.enqueueResult = (resultPromise: (previousResult: T | undefined) => Promise<T | undefined>) => {
            (this as any).resultAwaiter = this.resultAwaiter.then(resultPromise);
        };
    }

    public readonly enqueueResult: (resultPromise: (previousResult: T | undefined) => Promise<T | undefined>) => void;
}
